import { theme } from '@theme';
import styled from 'styled-components';

type OptionItemProps = {
  borderBottom?: boolean;
  paddingLeft?: number;
  selected?: boolean;
  width?: number;
  padding?: string;
};

export const OptionItem = styled.div.attrs({
  className: `form-check`,
})<OptionItemProps>`
  ${(props) =>
    props.selected &&
    `color: ${theme.palette.black} !important;
      background-color: ${theme.palette.lightGray}!important;`}
  padding: ${(props) => props.padding ?? '3px 12px'};
  display: flex;
  justify-content: space-between !important;
  width: 100%;
  border-bottom: ${(props) =>
    props.borderBottom ? `1px solid ${theme.palette.lightGrey}` : `auto`};
  & div {
    padding: 0 5px;
    display: flex;
    font-size: ${theme.typography.h6}px;
    justify-content: space-between;
  }
  & span {
    display: flex;
    width: ${(props) => props.width ?? '80'}%;
    color: #333333;
    font-weight: 500;
    word-break: break-word;

    &.filter-right {
      width: auto;

      & span {
        width: auto;
      }
    }
  }
  & span label {
    max-width: 80%;
  }
`;

export const PortfolioOptionItem = styled(OptionItem).attrs<OptionItemProps>({
  'data-testid': 'portfolio-option-item',
})<OptionItemProps>`
  margin-bottom: 0;
  ${(props) =>
    props.selected &&
    `color: ${theme.palette.black} !important;
    background-color: ${theme.palette.white}!important;`}
`;
